import ApiService from './ApiService';
// import ToastService from '../services/ToastService';

class AuthService {
  

  constructor(router) {
    this.router = router;
  }
  

  async login(email, password) {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/login",
        data: { email, password },
      });

      return response.data;
    } catch (error) {
      // Handle error
    }
  }

  async googleLogin(data) {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/googleSignin",
        data: data,
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("branch");
    localStorage.removeItem("address");
    // window.location.href = process.env.REACT_APP_BASE_PATH + "/login";
  }

  setCurrentUser(data) {
    localStorage.setItem("user", JSON.stringify(data));
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  removeCurrentUser() {
    localStorage.removeItem("user");
  }
}


const authServiceInstance = new AuthService();

export default authServiceInstance;


